import React from 'react';
import PriceMatrixCell from './PriceMatrixCell'

const PriceMatrixRow = (props) => {
  const { priceRow } = props;
  return (
    <tr className={props.groupName === 'grpa' ? 'row-best-price' : 'row-customer-price'}>
      {!props.hideQuantityCell &&
        <td
          className="qty"
          rowSpan={props.rowSpanQuantityCell}>{props.quantity}
        </td>}
      {props.leadTimes.map((leadTime, col) => {
        const price = priceRow[leadTime.toString()];
        return <PriceMatrixCell key={col} {...props} leadTime={leadTime} price={price} />
      })}
    </tr>
  );
};
PriceMatrixRow.defaultProps = {
  leadTimes: [],
  hideQuantityCell: false,
  rowSpanQuantityCell: 1,
};
export default PriceMatrixRow;
